import React, { useContext, useEffect, useState } from "react";
// another components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
// styled components
import { Table, Empty, Button, Modal, Radio, Input, message, Popover, Row, Col, DatePicker } from "antd";
const { TextArea } = Input;
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
import { Convocatoria, initialValuesConvocatoria } from "../../../../models/ConvocatoriasModel/convocatoria.model";
// icons
import { EyeOutlined, DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalAceptar } from "../../components/ModalAceptar";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import apiDocumentos from "../../../../api/Documentos/api-documentos";
import apiNotificaciones from "../../../../api/Notificaciones/api-notificaciones";
import { TemplateContext } from "../../../../utils/template_context";
import { DownloadFile } from "../../../../utils/DownloadFile";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import moment from "moment";
import { confirmarSubsanacion, mensajeSubsanacionIncorrecta } from "../../../../utils/verificacionSubsanacion";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import locale from 'antd/es/date-picker/locale/es_ES';

import { fechaCierre, momentCierre } from '../../../../utils/horaCierre';
import {
  esCartaDeConformacion,
  esDeclaracionDeResidencia,
  esDeclaracionUnificada,
  esFormularioEnLinea,
} from "../../../../utils/documentosGrupoConformado";
import {
  coloresEstado,
  formatFechaNacimiento,
  getTipoParticipante,
  getEstadoDocumento,
} from "../../../../utils/postulacionHelpers";

interface IProps {
  postulacion: PostulacionModel;
  setPostulacion: any;
  allPostulaciones: Array<PostulacionModel>;
  setAllPostulaciones: any;
  descargarArchivo: any;
  lineasConvocatoria: any;
  isBeps?: boolean;
  soloSubsanables?: boolean;
}


export const InformacionPostulacionSubsanar: React.FC<IProps> = (
  props: IProps
) => {

  const docsAdminConIndice = (props.postulacion?.documentos_administrativos || []).map((doc: any, idx: number) => ({
    ...doc,
    _originalIndex: idx,
  }));

  const docsAdminFiltrados = props.soloSubsanables
    ? docsAdminConIndice.filter((doc: any) => Boolean(doc.checksubsanable))
    : docsAdminConIndice;

  const [modalDocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const [nombreDocumento, setNombreDocumento] = useState<string>("");
  const [tipodocumento] = useState<string>("");
  const [indexDocumento, setIndexDocumento] = useState<number>(0);
  const [evento, setEvento] = useState<any>({});
  const [user, setUser] = useState<any>({});
  const [aceptarModalDocumento, setAceptarModalDocumento] =
    useState<boolean>(false);
  const [openModalEscritoVideo, setOpenModalEscritoVideo] = useState(false);
  const [datosEscritoVideo, setDatosEscritoVideo] = useState<any>({});
  //   functions
  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  const [convocatoria, setConvocatoria] = useState<Convocatoria>(initialValuesConvocatoria);

  const getConvocatoria = async () => {
    try {
      const res = await apiConvocatorias.getConvocatoriaById(props.postulacion.convocatoria_id);
      if (res?.data) {
        setConvocatoria(res.data);
      } else if (res) {
        setConvocatoria(res);
      }
    } catch (error) {
      console.error("Error fetching convocatoria:", error);
    }
  };

  useEffect(() => {
    getUser();
    getConvocatoria();
  }, [])

  const determinarFilenameFirma = (data: any): string | null => {
    if (data?.data) return data.data;
    if (typeof data === 'string') return data;
    return null;
  };

  const procesarArchivoFirma = async (archivo: any, urlFirmaActual: string | null): Promise<string | null> => {
    const data = await apiDocumentos.guardarArchivo(archivo);
    const filename = determinarFilenameFirma(data);
    if (filename && filename !== "/" && !filename.startsWith('blob:') && !filename.startsWith('data:')) {
      return filename;
    }
    console.error("Firma inválida guardada:", filename);
    return urlFirmaActual;
  };

  const firmar = async () => {
    const validaciones: [boolean, string][] = [
      [!preview, "Debe actualizar la firma"],
      [!direccion || direccion.trim() === "", "Debe ingresar la dirección"],
      [!pais || pais.trim() === "", "Debe ingresar el país"],
      [!ciudad || ciudad.trim() === "", "Debe ingresar la ciudad"],
      [!anosResidencia || anosResidencia.trim() === "", "Debe ingresar los años de residencia"],
      [ciudad === "MEDELLIN" && (!comuna || comuna.trim() === ""), "Debe ingresar la comuna"],
    ];
    for (const [esInvalido, mensaje] of validaciones) {
      if (esInvalido) {
        message.error(mensaje);
        return;
      }
    }

    const fechaActual = obtenerFechaFormateada();
    // Priorizar el nombre de archivo guardado en el documento si no hay archivo nuevo
    let urlFirma = filenameFirma || null;

    if (file) {
      try {
        urlFirma = await procesarArchivoFirma(file, urlFirma);
      } catch (err) {
        console.error(err);
        message.error("Error al guardar la firma");
        return;
      }
    }

    // Seguridad: Nunca guardar un blob o base64 en la base de datos
    if (urlFirma && (urlFirma.startsWith('blob:') || urlFirma.startsWith('data:'))) {
      urlFirma = null;
    }

    const obtenerFechaISO = () => {
      let f = new Date();
      return f.getFullYear() + '-' + ('0' + (f.getMonth() + 1)).slice(-2) + '-' + ('0' + f.getDate()).slice(-2) + ' ' + ('0' + f.getHours()).slice(-2) + ':' + ('0' + f.getMinutes()).slice(-2);
    }

    const docsParaMapear = Array.isArray(props.postulacion.documentos_administrativos)
      ? props.postulacion.documentos_administrativos
      : [];

    const nuevosdocumentos = docsParaMapear.map(
      (doc: any, indexdoc: number) => {
        if (indexDocumento === indexdoc) {
          return {
            ...doc,
            pais_residencia: paisResidencia,
            anos_residencia: anosResidencia,
            direccion: direccion,
            pais: pais,
            ciudad: ciudad,
            comuna: comuna,
            firma_declaracion: urlFirma,
            fecha_firma: fechaActual,
            correo: correo,
            telefono: celular,
            tipo_documento: user.tipo_identificacion?.split('-')[1],
            checksubsanable: false,
            checksubsanado: true,
            fecha_subsanado: obtenerFechaISO(),
            subsanado_por: `${user.nombres} ${user.apellidos}`
          };
        }
        return doc;
      }
    );

    try {
      await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        props.postulacion.id_postulacion,
        nuevosdocumentos
      );

      let estado = "Subsanado";
      if (nuevosdocumentos.filter((d: any) => d.checksubsanable).length > 0) {
        estado = "Subsanar";
      }

      await apiParticipantes.cambiarEstadoPostulacion({
        id_postulacion: props.postulacion.id_postulacion,
        estado: estado,
      });

      const updatedPostulation = {
        ...props.postulacion,
        estado,
        documentos_administrativos: nuevosdocumentos,
      };

      props.setPostulacion(updatedPostulation);

      const newAll = props.allPostulaciones.map((p: any) =>
        p.id_postulacion === props.postulacion.id_postulacion ? updatedPostulation : p
      );
      props.setAllPostulaciones(newAll);

      setOpenResidenciaModal(false);
      message.success("Declaración firmada y enviada correctamente");
    } catch (error) {
      console.error(error);
      message.error("Error al guardar la declaración");
    }
  };

  const AceptarModalDocumento = async () => {
    setAceptarModalDocumento(false);

    const obtenerFecha = () => {
      let fechaActual = new Date();
      let anio = fechaActual.getFullYear();
      let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
      let dia = ('0' + fechaActual.getDate()).slice(-2);
      let hora = ('0' + fechaActual.getHours()).slice(-2);
      let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
      return anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;
    }

    const fileToUpload = evento.target.files ? evento.target.files[0] : null;
    if (!fileToUpload) return;

    const formData = new FormData();
    formData.append("archivo", fileToUpload);

    // Visible también desde el catch: si el enlace falla, el archivo YA subió y hay que nombrarlo.
    let archivoSubido = "";

    try {
      let res = await apiDocumentos.guardarArchivo(formData);
      console.log("=== DEBUG guardarArchivo response ===", JSON.stringify(res));
      let filename: string | null;
      if (res?.data) { filename = res.data; }
      else if (typeof res === 'string') { filename = res; }
      else { filename = null; }
      console.log("=== DEBUG filename final ===", filename);


      if (!filename || filename === "" || filename === "/") {
        return message.error("Error: El servidor devolvió un nombre de archivo inválido.");
      }
      archivoSubido = filename;

      const nuevosdocumentos = props.postulacion.documentos_administrativos.map(
        (doc: any, indexdoc: number) => {
          if (indexDocumento === indexdoc) {
            let anterior = doc.url_participante
            return {
              ...doc,
              url_anterior: anterior,
              url_participante: filename,
              checksubsanable: false,
              checksubsanado: true,
              fecha_subsanado: obtenerFecha(),
              subsanado_por: `${user.nombres} ${user.apellidos}`
            };
          }
          return doc;
        }
      );

      await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        props.postulacion.id_postulacion,
        nuevosdocumentos
      );

      let estado = "Subsanado";
      let subsanar = nuevosdocumentos.filter((data: any) => data.checksubsanable);
      if (subsanar.length > 0) {
        estado = "Subsanar";
      }

      await apiParticipantes.cambiarEstadoPostulacion({
        id_postulacion: props.postulacion.id_postulacion,
        estado: estado,
      });

      // Releer desde el servidor antes de dar nada por hecho: el guardado pudo no cuajar, o otra
      // pantalla pudo sobrescribir la columna con una copia vieja. Nunca confirmar contra lo que
      // el navegador cree que mandó.
      const guardado = await apiParticipantes.consultarPostulacion(props.postulacion.id_postulacion);
      const confirmacion = confirmarSubsanacion(
        guardado?.data?.documentos_administrativos,
        indexDocumento,
        archivoSubido
      );

      if (!confirmacion.confirmada) {
        console.error("[Subsanación] No quedó registrada: " + confirmacion.motivo + " - " + confirmacion.detalle, {
          id_postulacion: props.postulacion.id_postulacion,
          archivo: archivoSubido,
        });
        return Modal.error({
          title: "Subsanación incorrecta",
          content: mensajeSubsanacionIncorrecta(archivoSubido),
          okText: "Entendido",
          width: 520,
        });
      }

      const updatedPostulation = {
        ...props.postulacion,
        estado,
        documentos_administrativos: nuevosdocumentos,
      };

      props.setPostulacion(updatedPostulation);

      const newAll = props.allPostulaciones.map((p: any) =>
        p.id_postulacion === props.postulacion.id_postulacion ? updatedPostulation : p
      );
      props.setAllPostulaciones(newAll);

      let payloadNotificacionAdmin = {
        tipo_notificacion: "Subsanación",
        nombre_proyecto: props.postulacion.nombre_propuesta,
        remitente: user.id_usuario,
        convocatoria_id: props.postulacion.convocatoria_id,
      };

      let notificacionCorreo = {
        tipo_participante: 1,
        tipo_notificacion: "Subsanación",
        id_postulacion: props.postulacion.id_postulacion,
        remitente: user.id_usuario,
        convocatoria_id: props.postulacion.convocatoria_id,
      };

      await apiNotificaciones.enviarNotificacionAdministrador(payloadNotificacionAdmin);
      await apiNotificaciones.enviarNotificacion(notificacionCorreo);

      message.success("Documento subsanado correctamente");

    } catch (error) {
      // El archivo ya subió al servidor de documentos. Si el enlace falló, el participante tiene
      // que enterarse de que NO quedó subsanado: un aviso que se desvanece fue justo lo que dejó
      // al caso C466-013 creyendo que había cumplido.
      console.error("[Subsanación] Falló el guardado", {
        id_postulacion: props.postulacion.id_postulacion,
        archivo: archivoSubido,
        error,
      });
      Modal.error({
        title: "Subsanación incorrecta",
        content: mensajeSubsanacionIncorrecta(archivoSubido || nombreDocumento || "(sin nombre)"),
        okText: "Entendido",
        width: 520,
      });
    }
  };
  const CancelarModalDocumento = () => {
    setAceptarModalDocumento(false);
  };
  const context = useContext(TemplateContext);


  const [anosResidencia, setAnosResidencia] = useState<string>("");
  const [direccion, setDireccion] = useState<string>("");
  const [pais, setPais] = useState<string>("");
  const [ciudad, setCiudad] = useState<string>("");
  const [comuna, setComuna] = useState<string>("");
  const [fechaFirma, setFechaFirma] = useState<string>("");
  const [correo, setCorreo] = useState<string>("");
  const [celular, setCelular] = useState<string>("");
  const [preview, setPreview] = useState<any>();
  const [file, setFile] = useState<any>();
  const [paisResidencia] = useState<string>("");
  const [filenameFirma, setFilenameFirma] = useState<string>("");
  const [isViewOnly, setIsViewOnly] = useState<boolean>(false);
  const [openResidenciaModal, setOpenResidenciaModal] = useState(false);
  const [openRelacionModal, setOpenRelacionModal] = useState(false);
  const [datosRelacion, setDatosRelacion] = useState<any>({});
  const [openCartaConformacionModal, setOpenCartaConformacionModal] = useState(false);
  const [datosCartaConformacion, setDatosCartaConformacion] = useState<any>({});
  const [openResidenciaGCModal, setOpenResidenciaGCModal] = useState(false);
  const [datosResidenciaGC, setDatosResidenciaGC] = useState<any>({});
  const [firmasParticipantes, setFirmasParticipantes] = useState<{ [key: number]: string }>({});
  const [nuevasFirmasParticipantes, setNuevasFirmasParticipantes] = useState<{ [key: number]: any }>({});
  const [firmaRepresentante, setFirmaRepresentante] = useState<string>("");
  const fileInputRef = React.useRef<any>(null);

  const normalizarTexto = (texto: string) =>
    texto
      .trim()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const obtenerFechaFormateada = () => {
    const fechaActual = new Date();
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
    const dia = fechaActual.getDate();
    const mes = meses[fechaActual.getMonth()];
    const anio = fechaActual.getFullYear();
    return `${dia} de ${mes} de ${anio}`;
  };

  const selectFile = (e: any) => {
    const { type } = e.target.files[0];

    if (type !== "image/png" && type !== "image/jpeg") {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png y .jpg",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", e.target.files[0]);

    setFile(formData);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  const getSignature = async (firma: string) => {
    if (!firma) return;
    if (firma.startsWith('data:image') || firma.startsWith('blob:')) {
      setPreview(firma);
      return;
    }
    try {
      const nombreArchivo = firma.split('/').pop() || firma;
      const data = await apiDocumentos.consultarArchivo(nombreArchivo);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          setPreview(reader.result as string);
        }
      }
    } catch (error) {
      console.error("Error al obtener la firma:", error);
    }
  };

  const getSignatureParticipante = async (firma: string, index: number) => {
    if (!firma) return;
    try {
      const nombreArchivo = firma.split('/').pop() || firma;
      const data = await apiDocumentos.consultarArchivo(nombreArchivo);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result as string;
          if (index === 0) {
            setFirmaRepresentante(base64String);
          }
          setFirmasParticipantes(prev => ({
            ...prev,
            [index]: base64String
          }));
        }
      }
    } catch (error) {
      console.error("Error al obtener la firma del participante:", error);
    }
  };

  const openResidenciaModalHandler = async (datos: any, index: number, viewOnly: boolean = false) => {

    setIsViewOnly(viewOnly);
    setIndexDocumento(index);
    setAnosResidencia(datos.anos_residencia || "");
    setDireccion(datos.direccion || "");
    setPais(datos.ciudad || "");
    setCiudad(datos.ciudad || "");
    setComuna(datos.comuna || "");
    setCorreo(datos.correo || user.correo || "");
    setCelular(datos.telefono || user.celular || "");
    setFechaFirma(datos.fecha_firma || "");

    // Cargar firma existente si la hay
    if (datos.firma_declaracion) {
      setFilenameFirma(datos.firma_declaracion);
      getSignature(datos.firma_declaracion);
    }
    setNuevasFirmasParticipantes({});
    setOpenResidenciaModal(true);
  };

  const getParticipantesFromOtherDocs = () => {
    if (props.postulacion.documentos_administrativos) {
      for (const doc of props.postulacion.documentos_administrativos) {
        if (esFormularioEnLinea(doc) && Array.isArray(doc.participantes) && doc.participantes.length > 0) {
          return JSON.parse(JSON.stringify(doc.participantes));
        }
      }
    }
    return null;
  };

  const openRelacionModalHandler = async (datos: any, index: number, viewOnly: boolean = false) => {
    setIsViewOnly(viewOnly);
    setIndexDocumento(index);
    const parsedDatos = JSON.parse(JSON.stringify(datos));

    if (!parsedDatos.participantes || !Array.isArray(parsedDatos.participantes) || parsedDatos.participantes.length === 0) {
      const existingParticipantes = getParticipantesFromOtherDocs();
      if (existingParticipantes) {
        parsedDatos.participantes = existingParticipantes;
      } else {
        parsedDatos.participantes = [];
      }
    }

    setDatosRelacion(parsedDatos);
    setFirmasParticipantes({});
    setNuevasFirmasParticipantes({});
    setFirmaRepresentante("");

    if (parsedDatos.participantes && Array.isArray(parsedDatos.participantes)) {
      parsedDatos.participantes.forEach((p: any, idx: number) => {
        if (p.firma) getSignatureParticipante(p.firma, idx);
      });
    }
    setOpenRelacionModal(true);
  };

  const openCartaConformacionModalHandler = async (datos: any, index: number, viewOnly: boolean = false) => {
    setIsViewOnly(viewOnly);
    setIndexDocumento(index);
    const parsedDatos = JSON.parse(JSON.stringify(datos));

    // Inicializar participantes si no existen o están vacíos
    if (!parsedDatos.participantes || !Array.isArray(parsedDatos.participantes) || parsedDatos.participantes.length === 0) {
      const existingParticipantes = getParticipantesFromOtherDocs();
      if (existingParticipantes) {
        parsedDatos.participantes = existingParticipantes;
      } else {
        parsedDatos.participantes = [{
          nombreGrupo: "",
          nombresApellidos: "",
          rol: "REPRESENTANTE",
          tipoDocumento: "CC",
          numeroDocumento: "",
          fechaNacimiento: null,
          edadCumplida: 0,
          direccionResidencia: "",
          ciudad: "",
          telefonoFijo: "",
          telefonoCelular: "",
          tiempoResidencia: "",
          correoElectronico: "",
        }];
      }
    }

    setDatosCartaConformacion(parsedDatos);
    setFirmasParticipantes({});
    setNuevasFirmasParticipantes({});
    setFirmaRepresentante("");

    if (parsedDatos.participantes && Array.isArray(parsedDatos.participantes)) {
      parsedDatos.participantes.forEach((p: any, idx: number) => {
        if (p.firma) getSignatureParticipante(p.firma, idx);
      });
    }
    setOpenCartaConformacionModal(true);
  };

  const openResidenciaGCModalHandler = async (datos: any, index: number, viewOnly: boolean = false) => {
    setIsViewOnly(viewOnly);
    setIndexDocumento(index);
    const parsedDatos = JSON.parse(JSON.stringify(datos));

    // Inicializar participantes si no existen o están vacíos
    if (!parsedDatos.participantes || !Array.isArray(parsedDatos.participantes) || parsedDatos.participantes.length === 0) {
      const existingParticipantes = getParticipantesFromOtherDocs();
      if (existingParticipantes) {
        parsedDatos.participantes = existingParticipantes;
      } else {
        parsedDatos.participantes = [{
          nombreGrupo: "",
          nombresApellidos: "",
          rol: "REPRESENTANTE",
          tipoDocumento: "CC",
          numeroDocumento: "",
          fechaNacimiento: null,
          edadCumplida: 0,
          direccionResidencia: "",
          ciudad: "",
          telefonoFijo: "",
          telefonoCelular: "",
          tiempoResidencia: "",
          correoElectronico: "",
        }];
      }
    }

    setDatosResidenciaGC(parsedDatos);
    setFirmasParticipantes({});
    setNuevasFirmasParticipantes({});
    setFirmaRepresentante("");

    if (parsedDatos.participantes && Array.isArray(parsedDatos.participantes)) {
      parsedDatos.participantes.forEach((p: any, idx: number) => {
        if (p.firma) getSignatureParticipante(p.firma, idx);
      });
    }
    setOpenResidenciaGCModal(true);
  };

  const calcularEdad = (fecha: any): number => {
    if (!fecha) return 0;
    const birthDate = moment(fecha);
    const hoy = moment();
    let edad = hoy.year() - birthDate.year();
    if (
      hoy.month() < birthDate.month() ||
      (hoy.month() === birthDate.month() && hoy.date() < birthDate.date())
    ) {
      edad--;
    }
    return edad;
  };

  const disabledFechaNacimiento = (current: any) => {
    if (convocatoria.menor_edad) {
      return false;
    }
    const fechaLimite = moment().subtract(18, "years");
    return current.isAfter(fechaLimite, "day");
  };

  const validarParticipantesArea = (participantes: any[]) => {
    const total = participantes.length;
    if (total === 0) return false;
    const ciudadesPermitidas = [
      "MEDELLIN", "CALDAS", "LA ESTRELLA", "LAESTRELLA", "ESTRELLA",
      "SABANETA", "ENVIGADO", "ITAGUI", "BELLO", "COPACABANA",
      "GIRARDOTA", "BARBOSA"
    ];
    const participantesMedellin = participantes.filter(p => {
      const ciudadTexto = normalizarTexto(p.ciudad || "");
      const ciudadSinEspacios = ciudadTexto.replace(/\s+/g, "");
      return ciudadesPermitidas.includes(ciudadTexto) || ciudadesPermitidas.includes(ciudadSinEspacios);
    }).length;
    const minimoRequerido = Math.ceil(total * 0.6);
    return participantesMedellin >= minimoRequerido;
  };

  const validarParticipantesMedellin = (participantes: any[]) => {
    const total = participantes.length;
    if (total === 0) return false;
    const ciudadesPermitidas = ["MEDELLIN"];
    const participantesMedellin = participantes.filter(p => {
      const ciudadTexto = normalizarTexto(p.ciudad || "");
      const ciudadSinEspacios = ciudadTexto.replace(/\s+/g, "");
      return ciudadesPermitidas.includes(ciudadTexto) || ciudadesPermitidas.includes(ciudadSinEspacios);
    }).length;
    const minimoRequerido = Math.ceil(total * 0.6);
    return participantesMedellin >= minimoRequerido;
  };

  const handleParticipantDataChange = (tipo: string, indexParticipante: number, campo: string, valor: any) => {
    let finalValue = valor;
    let extraChanges: any = {};

    if (campo === 'fechaNacimiento') {
      const edad = calcularEdad(valor);
      extraChanges['edadCumplida'] = edad;
    }

    if (tipo === 'relacion') {
      const nuevosDatos = { ...datosRelacion };
      nuevosDatos.participantes[indexParticipante][campo] = finalValue;
      Object.assign(nuevosDatos.participantes[indexParticipante], extraChanges);
      setDatosRelacion(nuevosDatos);
    } else if (tipo === 'carta') {
      const nuevosDatos = { ...datosCartaConformacion };
      if (campo === 'nombreGrupo') {
        nuevosDatos.nombreGrupo = finalValue;
        nuevosDatos.participantes = nuevosDatos.participantes?.map((p: any) => ({ ...p, nombreGrupo: finalValue })) ?? nuevosDatos.participantes;
      } else {
        nuevosDatos.participantes[indexParticipante][campo] = finalValue;
        Object.assign(nuevosDatos.participantes[indexParticipante], extraChanges);
      }
      setDatosCartaConformacion(nuevosDatos);
    } else if (tipo === 'residenciaGC') {
      const nuevosDatos = { ...datosResidenciaGC };
      if (campo === 'nombreGrupo') {
        nuevosDatos.nombreGrupo = finalValue;
        nuevosDatos.participantes = nuevosDatos.participantes?.map((p: any) => ({ ...p, nombreGrupo: finalValue })) ?? nuevosDatos.participantes;
      } else {
        nuevosDatos.participantes[indexParticipante][campo] = finalValue;
        Object.assign(nuevosDatos.participantes[indexParticipante], extraChanges);
      }
      setDatosResidenciaGC(nuevosDatos);
    }
  };

  const addParticipant = (tipo: string) => {
    let currentParticipantes: any[] = [];
    if (tipo === 'relacion') currentParticipantes = datosRelacion.participantes || [];
    else if (tipo === 'carta') currentParticipantes = datosCartaConformacion.participantes || [];
    else if (tipo === 'residenciaGC') currentParticipantes = datosResidenciaGC.participantes || [];

    if (currentParticipantes.length > 0) {
      const last = currentParticipantes[currentParticipantes.length - 1];
      const incomplete = !last.nombresApellidos || !last.rol || !last.tipoDocumento || !last.numeroDocumento || !last.fechaNacimiento || !last.direccionResidencia || !last.ciudad || !last.correoElectronico;
      if (incomplete) {
        return message.warning("Debe completar todos los campos del participante actual antes de agregar uno nuevo.");
      }
    }

    const nuevoParticipante = {
      nombresApellidos: "",
      rol: "",
      tipoDocumento: "",
      numeroDocumento: "",
      fechaNacimiento: null,
      edadCumplida: "",
      direccionResidencia: "",
      ciudad: "",
      telefonoFijo: "",
      telefonoCelular: "",
      tiempoResidencia: "",
      correoElectronico: "",
      nombreGrupo: currentParticipantes?.[0]?.nombreGrupo || ""
    };

    if (tipo === 'relacion') {
      const nuevosDatos = { ...datosRelacion };
      if (!nuevosDatos.participantes) nuevosDatos.participantes = [];
      nuevosDatos.participantes.push(nuevoParticipante);
      setDatosRelacion(nuevosDatos);
    } else if (tipo === 'carta') {
      const nuevosDatos = { ...datosCartaConformacion };
      if (!nuevosDatos.participantes) nuevosDatos.participantes = [];
      nuevosDatos.participantes.push(nuevoParticipante);
      setDatosCartaConformacion(nuevosDatos);
    } else if (tipo === 'residenciaGC') {
      const nuevosDatos = { ...datosResidenciaGC };
      if (!nuevosDatos.participantes) nuevosDatos.participantes = [];
      nuevosDatos.participantes.push(nuevoParticipante);
      setDatosResidenciaGC(nuevosDatos);
    }
  };

  const handleParticipantSignatureChange = (indexParticipante: number, e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/jfif"];
    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!allowedTypes.includes(file.type) && extension !== 'jfif' && extension !== 'jpg' && extension !== 'jpeg') {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png, .jpg y .jfif",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", file);

    setNuevasFirmasParticipantes(prev => ({ ...prev, [indexParticipante]: formData }));
    setFirmasParticipantes(prev => ({ ...prev, [indexParticipante]: URL.createObjectURL(file) }));
  };

  const shiftSignatures = (idx: number) => {
    setFirmasParticipantes(prev => {
      const next: any = {};
      Object.keys(prev).forEach(key => {
        const k = parseInt(key);
        if (k < idx) next[k] = prev[k];
        else if (k > idx) next[k - 1] = prev[k];
      });
      return next;
    });
    setNuevasFirmasParticipantes(prev => {
      const next: any = {};
      Object.keys(prev).forEach(key => {
        const k = parseInt(key);
        if (k < idx) next[k] = prev[k];
        else if (k > idx) next[k - 1] = prev[k];
      });
      return next;
    });
  };

  const removeParticipant = (tipo: string, index: number) => {

    if (tipo === 'relacion') {
      const nuevosDatos = { ...datosRelacion };
      nuevosDatos.participantes.splice(index, 1);
      setDatosRelacion(nuevosDatos);
      shiftSignatures(index);
    } else if (tipo === 'carta') {
      const nuevosDatos = { ...datosCartaConformacion };
      nuevosDatos.participantes.splice(index, 1);
      setDatosCartaConformacion(nuevosDatos);
      shiftSignatures(index);
    } else if (tipo === 'residenciaGC') {
      const nuevosDatos = { ...datosResidenciaGC };
      nuevosDatos.participantes.splice(index, 1);
      setDatosResidenciaGC(nuevosDatos);
      shiftSignatures(index);
    }
  };

  const guardarSubsanacionParticipantes = async (tipo: string) => {
    let datosAEnviar: any;
    let setModal: any;

    if (tipo === 'relacion') {
      datosAEnviar = { ...datosRelacion };
      setModal = setOpenRelacionModal;
    } else if (tipo === 'carta') {
      datosAEnviar = { ...datosCartaConformacion };
      setModal = setOpenCartaConformacionModal;
    } else if (tipo === 'residenciaGC') {
      datosAEnviar = { ...datosResidenciaGC };
      setModal = setOpenResidenciaGCModal;
    }

    if (tipo === 'carta' || tipo === 'residenciaGC') {
      const participantes = datosAEnviar.participantes || [];
      if (participantes.length > 0) {
        const isAltavoz = props.postulacion.nombre_convocatoria?.toLowerCase().includes('altavoz');
        if (isAltavoz) {
          if (!validarParticipantesArea(participantes)) {
            return message.error("Al menos el 60% de los participantes deben ser de Medellín o el área metropolitana");
          }
        } else {
          if (!validarParticipantesMedellin(participantes)) {
            return message.error("Al menos el 60% de los participantes deben ser de Medellín");
          }
        }
      }
    }

    // Subir nuevas firmas de participantes si las hay
    const indicesAFirmar = Object.keys(nuevasFirmasParticipantes);
    for (const key of indicesAFirmar) {
      const idx = parseInt(key);
      try {
        const res = await apiDocumentos.guardarArchivo(nuevasFirmasParticipantes[idx]);
        let filename: string | null;
      if (res?.data) { filename = res.data; }
      else if (typeof res === 'string') { filename = res; }
      else { filename = null; }

        if (filename && filename !== "" && filename !== "/" && !filename.startsWith('blob:') && !filename.startsWith('data:')) {
          console.log(`Guardando firma para participante ${idx}:`, filename);
          datosAEnviar.participantes[idx].firma = filename;
        } else {
          console.error(`Firma inválida recibida para participante ${idx}:`, filename);
          // Opcional: si es crítico, podríamos lanzar un error aquí
        }
      } catch (error) {
        console.error("Error al subir firma de participante:", error);
        return message.error(`Error al subir la firma del participante ${idx + 1}`);
      }
    }

    const obtenerFechaISO = () => {
      let f = new Date();
      return f.getFullYear() + '-' + ('0' + (f.getMonth() + 1)).slice(-2) + '-' + ('0' + f.getDate()).slice(-2) + ' ' + ('0' + f.getHours()).slice(-2) + ':' + ('0' + f.getMinutes()).slice(-2);
    }

    const fechaActual = obtenerFechaFormateada();
    const nuevosdocumentos = props.postulacion.documentos_administrativos.map(
      (doc: any, indexdoc: number) => {
        if (indexDocumento === indexdoc) {
          return {
            ...datosAEnviar,
            fecha_firma: datosAEnviar.fecha_firma || fechaActual,
            checksubsanable: false,
            checksubsanado: true,
            fecha_subsanado: obtenerFechaISO(),
            subsanado_por: `${user.nombres} ${user.apellidos}`
          };
        }
        return doc;
      }
    );

    try {
      await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        props.postulacion.id_postulacion,
        nuevosdocumentos
      );

      let estado = "Subsanado";
      if (nuevosdocumentos.filter((d: any) => d.checksubsanable).length > 0) {
        estado = "Subsanar";
      }

      await apiParticipantes.cambiarEstadoPostulacion({
        id_postulacion: props.postulacion.id_postulacion,
        estado: estado,
      });

      const updatedPostulation = {
        ...props.postulacion,
        estado,
        documentos_administrativos: nuevosdocumentos,
      };

      props.setPostulacion(updatedPostulation);
      const newAll = props.allPostulaciones.map((p: any) =>
        p.id_postulacion === props.postulacion.id_postulacion ? updatedPostulation : p
      );
      props.setAllPostulaciones(newAll);

      setModal(false);
      message.success("Documento subsanado correctamente");
    } catch (error) {
      console.error(error);
      message.error("Error al guardar la subsanación");
    }
  };

  // columns
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 120,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12">
            {datos.tipo_documento || datos.descripcion}
          </div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 300,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            {(() => {
              if (datos.tipo_documento !== "Escrito y Video") return <span>{datos.url_participante}</span>;
              if (datos.escrito || datos.url_video) return <span>Diligenciado en el sistema</span>;
              return <span>No se cargó información</span>;
            })()}
          </>
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            {datos.checkaceptartecnico !== undefined ? (
              <div className="row">
                <div className="col-12 justify-content-center">
                  {datos.checkaceptartecnico === true ? (
                    <span style={{ color: coloresEstado["Aceptado"] }}>
                      Aceptado
                    </span>
                  ) : (
                    <span style={{ color: coloresEstado["Rechazado"] }}>
                      Rechazado
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="justify-content-center">
                <span>Inscrito sin revisar</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <div>Acciones</div>
          <div style={{ display: "flex", justifyContent: "center", gap: "16px", fontSize: "11px", color: "#666" }}>
            <span>Ver</span>
            <span>Desc.</span>
          </div>
        </div>
      ),
      width: 130,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        const isEscritoVideo = datos.tipo_documento === "Escrito y Video";
        const hasContent = datos.url_documento || datos.url_participante || (isEscritoVideo && (datos.escrito || datos.url_video));

        if (hasContent) {
          return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <EyeOutlined
                  className="font-size-13px"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (isEscritoVideo) {
                      setDatosEscritoVideo(datos);
                      setOpenModalEscritoVideo(true);
                    } else {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {!isEscritoVideo && (
                  <DownloadOutlined
                    className="font-size-13px"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      DownloadFile(datos.url_participante)
                    }
                  />
                )}
              </div>
            </div>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{ fontSize: 'small' }}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{ fontWeight: 'bold' }}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{ fontWeight: 'bold' }}>{datos.subsanado_por}</span></p>
                      {datos.url_anterior && (
                        <p className="font-color-6435C9">Ver anterior: {' '}
                          <span style={{ fontWeight: 'bold' }}>
                            <EyeOutlined
                              onClick={() => {
                                setModalDocumento(true);
                                setDocumento(datos.url_anterior);
                              }} />
                          </span>
                        </p>)
                      }
                    </div>
                  }>
                  <InfoCircleOutlined />
                </Popover>
              </Col>
            </Row>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>Estado</div>
      ),
      width: 110,
      render: (datos: any, record: any, index: number) => {
        return (
          <div style={{ textAlign: "center", whiteSpace: "nowrap" }}>
            {getEstadoDocumento(datos)}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <div>Acciones</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginTop: "2px", fontSize: "11px", color: "#666" }}>
            <span style={{ minWidth: "140px", textAlign: "center" }}></span>
            <span style={{ width: "28px", textAlign: "center" }}>Ver</span>
            <span style={{ width: "28px", textAlign: "center" }}>Desc.</span>
          </div>
        </div>
      ),
      width: 250,
      render: (datos: any, record: any, index: number) => {
        const originalIndex = datos?._originalIndex ?? record?._originalIndex ?? index;
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", flexWrap: "nowrap" }}>
            <div style={{ minWidth: "140px", display: "flex", justifyContent: "center" }}>
              {datos.checksubsanable ? (
                <>
                  <Button
                    onClick={async () => {
                      const convocatoria = await apiConvocatorias.getConvocatoriaById(props.postulacion.convocatoria_id)
                      for (const element of convocatoria.data.fechas) {
                        if (element.clave !== "Plazo para subsanar documentos y presentar observaciones") continue;
                        const fechaActual = moment();
                        const cierreAct = fechaCierre(element.valormax);
                        const fechaYHoraActualizada = `${cierreAct.getFullYear()}-${('0'+(cierreAct.getMonth()+1)).slice(-2)}-${('0'+cierreAct.getDate()).slice(-2)} ${('0'+cierreAct.getHours()).slice(-2)}:${('0'+cierreAct.getMinutes()).slice(-2)}`;
                        if (!fechaActual.isBefore(moment(fechaYHoraActualizada)) || !fechaActual.isAfter(moment(element.valormin))) {
                          return openNotification({
                            titulo: "Error",
                            descripcion: `Solo se permiten subsanar en las fechas estipuladas desde ${moment(element.valormin.substring(0, 10)).format("LL")}, hasta ${momentCierre(element.valormax).format("LLL")}`,
                            placement: "bottomRight",
                          });
                        }
                        if (esDeclaracionDeResidencia(datos) || esDeclaracionUnificada(datos)) {
                          if (["3", "2"].includes(props.postulacion.tipo_participante)) {
                            openResidenciaGCModalHandler(datos, originalIndex);
                          } else {
                            openResidenciaModalHandler(datos, originalIndex);
                          }
                        } else if (datos.descripcion === 'Relación de participantes de la propuesta') {
                          openRelacionModalHandler(datos, originalIndex);
                        } else if (esCartaDeConformacion(datos)) {
                          openCartaConformacionModalHandler(datos, originalIndex);
                        } else {
                          const inputEl = (document.getElementById(`inputs-ref-subsanar-${originalIndex}`) as HTMLElement) ||
                            (document.getElementsByClassName("inputs-ref-subsanar-mis-postulaciones")[index] as HTMLElement);
                          inputEl?.click();
                        }
                      }
                    }}
                    className="no-margin button-azul-ghost font-family-Montserrat-Medium"
                    style={{
                      whiteSpace: "nowrap",
                      padding: "4px 8px",
                      fontSize: "11.5px",
                      height: "auto",
                      lineHeight: "1.2",
                    }}
                  >
                    Subsanar documento
                  </Button>
                  <input
                    id={`inputs-ref-subsanar-${originalIndex}`}
                    className="inputs-ref-subsanar-mis-postulaciones"
                    type="file"
                    hidden
                    onChange={async (e: any) => {
                      if (e.target.files!.length > 0) {
                        if (e.target.files[0].type === "application/pdf") {
                          const { name } = e.target.files![0];
                          setNombreDocumento(name);
                          setEvento(e);
                          setIndexDocumento(originalIndex);
                          return setAceptarModalDocumento(true);
                        }
                        return openNotification({
                          titulo: "Error",
                          descripcion: "Solo se permiten archivos PDF",
                          placement: "bottomRight",
                        });
                      }
                      e.target.value = "";
                    }}
                  />
                </>
              ) : (
                <input
                  id={`inputs-ref-subsanar-${originalIndex}`}
                  className="inputs-ref-subsanar-mis-postulaciones"
                  type="file"
                  hidden
                />
              )}
            </div>
            <div style={{ width: "28px", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <EyeOutlined
                className="font-size-13px"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (esDeclaracionDeResidencia(datos) || esDeclaracionUnificada(datos)) {
                    if (props.postulacion.tipo_participante === "3" || props.postulacion.tipo_participante === "2") {
                      openResidenciaGCModalHandler(datos, originalIndex, true);
                    } else {
                      // For Persona Natural
                      if (datos.firma_declaracion || datos.url_participante?.includes('firma_')) {
                        openResidenciaModalHandler(datos, originalIndex, true);
                      } else {
                        setModalDocumento(true);
                        setDocumento(datos.url_participante);
                      }
                    }
                  } else if (datos.descripcion === 'Relación de participantes de la propuesta') {
                    openRelacionModalHandler(datos, originalIndex, true);
                  } else if (esCartaDeConformacion(datos)) {
                    openCartaConformacionModalHandler(datos, originalIndex, true);
                  } else {
                    setModalDocumento(true);
                    setDocumento(datos.url_participante);
                  }
                }}
              />
            </div>
            <div style={{ width: "28px", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <DownloadOutlined
                className="font-size-13px"
                style={{ cursor: "pointer" }}
                onClick={() => DownloadFile(datos.url_participante)}
              />
            </div>
          </div>
        );
      },
    },
  ];
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        return (
          <div className="row">
            <div className="col-12">
              <a target="_blank" href={datos.url}>
                {datos.url}
              </a>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div
          className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Nombre representante
        </div>
        <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
          {props.postulacion.nombre_participante}
        </div>
        {props.isBeps ? null : (
          <>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {getTipoParticipante(props.postulacion.tipo_participante)}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Categorías
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.categoria_linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Observaciones
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
            >
              {props.postulacion.observaciones}
            </div>
          </>
        )}
        {props.soloSubsanables && (
          <div className="col-12">
            <div className="alerta-subsanar-info">
              <strong>Atención:</strong> A continuación se muestran únicamente los documentos marcados con observaciones para subsanar. Haz clic en <strong>"Subsanar documento"</strong> para cargar tu nuevo archivo en formato PDF.
            </div>
          </div>
        )}
        {!props.soloSubsanables &&
          props.postulacion.documentos_tecnicos !== null &&
          props.postulacion.documentos_tecnicos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentaciontecnicaModal}
              scroll={{ x: 750 }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </div>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
          props.postulacion.documentos_administrativos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              {props.soloSubsanables ? "Documentos administrativos por subsanar" : "Documentos administrativos"}
            </span>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionadministrativaModal}
              scroll={{ x: 880 }}
              locale={{
                emptyText: (
                  <Empty
                    description={
                      props.soloSubsanables
                        ? "No hay documentos pendientes por subsanar para esta postulación"
                        : "No se han diligenciados datos para está sección"
                    }
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={docsAdminFiltrados}
            />
          </div>
        ) : null}
        {!props.soloSubsanables && props.postulacion.links !== null ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <span className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </span>
            <Table
              pagination={false}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              scroll={{ x: 500 }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </div>
        ) : null}
      </div>
      <ModalVisualizarDocumentos
        visualizar={modalDocumento}
        setVisualizar={setModalDocumento}
        state={{ documento: documento }}
        tipo="participante"
      />
      <Modal
        title={
          <div className="font-family-Montserrat-Bold font-size-22px color-0050A0 d-flex align-items-center">
            <EyeOutlined style={{ marginRight: '12px', fontSize: '26px' }} />
            Visualizar Escrito y Video
          </div>
        }
        visible={openModalEscritoVideo}
        onCancel={() => setOpenModalEscritoVideo(false)}
        width={900}
        centered
        footer={[
          <Button
            key="close"
            onClick={() => setOpenModalEscritoVideo(false)}
            className="button-blanco-radius"
          >
            Cerrar
          </Button>
        ]}
      >
        <div className="p-3">
          <div className="mb-4">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              Escrito o Narración de la Propuesta:
            </span>
            <TextArea
              rows={12}
              value={datosEscritoVideo?.escrito}
              disabled
              className="mt-1 font-family-Montserrat-Regular"
              style={{ borderRadius: '8px', padding: '12px', border: '1px solid #d9d9d9', color: 'rgba(0, 0, 0, 0.85)', backgroundColor: '#f5f5f5' }}
            />
          </div>
          <div className="mt-5">
            <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
              URL del video de soporte:
            </span>
            <div className="mt-1 p-3" style={{ border: '1px solid #d9d9d9', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
              <a
                href={datosEscritoVideo?.url_video}
                target="_blank"
                rel="noopener noreferrer"
                className="font-family-Montserrat-Regular"
                style={{ color: '#0050A0', textDecoration: 'underline' }}
              >
                {datosEscritoVideo?.url_video}
              </a>
            </div>
          </div>
        </div>
      </Modal>
      <ModalAceptar
        modal={aceptarModalDocumento}
        AceptarModal={AceptarModalDocumento}
        CancelarModal={CancelarModalDocumento}
        CancelarArchivo={CancelarModalDocumento}
        TipoDocumento={tipodocumento}
        NombreArchivo={nombreDocumento}
      />
      <Modal
        zIndex={2000}
        style={{ top: 20 }}
        visible={openResidenciaModal}
        footer={null}
        width={800}
        maskClosable={true}
        onCancel={() => setOpenResidenciaModal(false)}
        maskStyle={{
          background: "rgba(12, 164, 93, 0.4)",
        }}
        className="modal-postulacion-exitosa"
      >
        <div className="document-wrapper">
          <div id="modal_custom" className="document-page">

            <h3 className="text-center">
              DECLARACIÓN JURAMENTADA DE RESIDENCIA
            </h3>

            <p className="text-justify">
              Señores, <br />
              {props.postulacion.linea_convocatoria?.toString().includes('SM -') ? (
                <>
                  <strong>Convocatoria Estímulos a los Talentos y Liderazgos de las Mujeres</strong> <br />
                  Secretaría de las Mujeres <br />
                </>
              ) : (
                <>
                  <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                  Secretaría de Cultura Ciudadana <br />
                </>
              )}
              Alcaldía de Medellín <br />
              Distrito de Ciencia, Tecnología e Innovación

            </p>
            <br />
            <p className="text-justify">
              Yo, <strong>{user.nombres} {user.apellidos}</strong>, identificado(a) con{" "}
              <strong> {user.tipo_identificacion?.split('-')[1]}</strong> número{" "}
              <strong> {user.documento}</strong>, manifiesto bajo{" "}
              gravedad de juramento que mi lugar de residencia es
              <Input
                value={pais}
                onChange={(e) => setPais(e.target.value)}
                placeholder="Ingrese Ciudad"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
              {" "} y lo ha sido durante los
              últimos{" "}
              <Input
                type="number"
                value={anosResidencia}
                onChange={(e) => {
                  const val = e.target.value;
                  if (Number(val) < 0) return;
                  setAnosResidencia(val);
                }}
                onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                    e.preventDefault();
                  }
                }}
                placeholder="Años"
                min={2}
                style={{ display: "inline-block", width: "80px", margin: "0 5px" }}
              />{" "}
              años.
            </p>
            <br />
            <p>
              <strong>Dirección: </strong>
              <Input
                value={direccion}
                onChange={(e) => setDireccion(e.target.value)}
                placeholder="Ingrese la dirección"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "300px", marginLeft: "10px" }}
              />
            </p>
            <p>
              <strong>Ciudad: </strong>
              <Input
                value={ciudad}
                onChange={(e) => setCiudad(e.target.value)}
                placeholder="Ingrese ciudad"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
            </p>

            {normalizarTexto(ciudad) === "MEDELLIN" && (
              <div>
                <strong>Comuna: </strong>
                <Input
                  value={comuna}
                  onChange={(e) => setComuna(e.target.value)}
                  placeholder="Ingrese comuna"
                  disabled={isViewOnly}
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
              </div>
            )}
            <p>
              <strong>Correo electrónico: </strong>
              <Input
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="Ingrese correo electrónico"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "250px", marginLeft: "10px" }}
              />
            </p>
            <p>
              <strong>Teléfono: </strong>
              <Input
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                placeholder="Ingrese teléfono"
                disabled={isViewOnly}
                style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
              />
            </p>

            <br />

            <p className="text-right">
              En constancia, se firma en {fechaFirma || obtenerFechaFormateada()}
              {preview && (preview.startsWith('data:image') || preview.startsWith('blob:')) && (
                <img
                  src={preview}
                  style={{
                    height: "auto",
                    maxHeight: "100px",
                    width: "auto",
                    display: "block",
                    marginLeft: "auto"
                  }}
              alt="Firma"
              />
              )}
            </p>
          </div>
        </div>
        {!isViewOnly && (
          <div className="acciones-documento" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '15px' }}>
            <div className="accion-firma">
              <span style={{ display: 'block', marginBottom: '5px' }}>
                Actualizar firma:
              </span>

              <input
                ref={fileInputRef}
                type="file"
                onChange={selectFile}
              />
            </div>

            <div className="accion-botones">
              <Button type="primary" onClick={firmar} style={{ background: '#0CA45D', borderColor: '#0CA45D' }}>
                Firmar y Guardar
              </Button>
            </div>
          </div>
        )}

      </Modal>
      {openRelacionModal && (
        <Modal
          style={{ top: 20, zIndex: 3 }}
          visible={openRelacionModal}
          footer={null}
          width={900}
          maskClosable={true}
          onCancel={() => setOpenRelacionModal(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom" className="document-page">
              <h3 className="text-center">
                RELACIÓN DE PARTICIPANTES DE LA PROPUESTA
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                <strong>
                  Asunto: Relación de participantes para propuestas de personas jurídicas
                </strong>
              </p>
              <p className="text-justify">
                A continuación, relacionamos las personas que desarrollarán la propuesta {" "}
                <strong>{datosRelacion?.datos_empresa?.razon_social}</strong> presentada en la {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong>.
              </p>
              <div>
                {datosRelacion?.participantes && Array.isArray(datosRelacion.participantes) && datosRelacion.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '13px' }}>
                      <InfoCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
                      <strong>Nota:</strong> El primer participante que se agrega se considera el representante.
                    </div>
                    {datosRelacion.participantes.map((participante: any, index: number) => {
                      const fechaNacimiento = formatFechaNacimiento(participante.fechaNacimiento);

                      return (
                        <div
                          key={participante.documento || participante.nombresApellidos}
                          style={{
                            border: '1px solid #ddd',
                            padding: '15px',
                            marginBottom: '10px',
                            borderRadius: '4px',
                            backgroundColor: '#fafafa',
                            position: 'relative'
                          }}
                        >
                          {!isViewOnly && (
                            <Button
                              type="text"
                              danger
                              icon={<i className="fa fa-trash" />}
                              style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1 }}
                              onClick={() => removeParticipant("relacion", index)}
                            />
                          )}
                          {isViewOnly ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px' }}>
                              <div><strong>Nombres:</strong> {participante.nombresApellidos || "—"}</div>
                              <div><strong>Rol:</strong> {participante.rol || "—"}</div>
                              <div><strong>Tipo Doc:</strong> {participante.tipoDocumento || "—"}</div>
                              <div><strong>N° Doc:</strong> {participante.numeroDocumento || "—"}</div>
                              <div><strong>Fecha Nacimiento:</strong> {fechaNacimiento || "—"}</div>
                              <div><strong>Edad:</strong> {participante.edadCumplida || "—"}</div>
                              <div><strong>Dirección:</strong> {participante.direccionResidencia || "—"}</div>
                              <div><strong>Ciudad:</strong> {participante.ciudad || "—"}</div>
                              <div><strong>Tel. Fijo:</strong> {participante.telefonoFijo || "—"}</div>
                              <div><strong>Tel. Celular:</strong> {participante.telefonoCelular || "—"}</div>
                              <div><strong>Tiempo Residencia:</strong> {participante.tiempoResidencia || "—"} años</div>
                              <div><strong>Correo:</strong> {participante.correoElectronico || "—"}</div>
                            </div>
                          ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '11px' }}>
                              <div><strong>Nombres:</strong> <Input size="small" value={participante.nombresApellidos} onChange={(e) => handleParticipantDataChange('relacion', index, 'nombresApellidos', e.target.value)} /></div>
                              <div><strong>Rol:</strong> <Input size="small" value={participante.rol} onChange={(e) => handleParticipantDataChange('relacion', index, 'rol', e.target.value)} /></div>
                              <p className="text-justify" style={{ gridColumn: 'span 2' }}>
                                <strong>Tipo de documento: </strong>
                                <Radio.Group
                                  value={participante.tipoDocumento}
                                  onChange={(e) => handleParticipantDataChange('relacion', index, 'tipoDocumento', e.target.value)}
                                >
                                  <Radio value="CC">CC</Radio>
                                  <Radio value="CE">CE</Radio>
                                  {convocatoria.menor_edad && (
                                    <Radio value="TI">TI</Radio>
                                  )}
                                </Radio.Group>
                              </p>
                              <div><strong>N° Doc:</strong> <Input size="small" value={participante.numeroDocumento} onChange={(e) => handleParticipantDataChange('relacion', index, 'numeroDocumento', e.target.value)} /></div>
                              <p className="text-justify">
                                <strong>Fecha de nacimiento:</strong>
                                <DatePicker
                                  value={participante.fechaNacimiento ? moment(participante.fechaNacimiento) : null}
                                  disabledDate={disabledFechaNacimiento}
                                  style={{ width: '100%' }}
                                  onChange={(date) => handleParticipantDataChange('relacion', index, 'fechaNacimiento', date)}
                                  format="YYYY-MM-DD"
                                  locale={locale}
                                />
                                {!convocatoria.menor_edad && participante.edadCumplida !== "" && participante.edadCumplida < 18 && (
                                  <small style={{ color: "#faad14" }}>
                                    {" "}No se permiten menores de 18 años
                                  </small>
                                )}
                              </p>
                              <div><strong>Edad:</strong> <Input size="small" value={participante.edadCumplida} readOnly disabled /></div>
                              <div><strong>Dirección:</strong> <Input size="small" value={participante.direccionResidencia} onChange={(e) => handleParticipantDataChange('relacion', index, 'direccionResidencia', e.target.value)} /></div>
                              <div><strong>Ciudad:</strong> <Input size="small" value={participante.ciudad} onChange={(e) => handleParticipantDataChange('relacion', index, 'ciudad', e.target.value)} /></div>
                              <div><strong>Tel. Fijo:</strong> <Input size="small" value={participante.telefonoFijo} onChange={(e) => handleParticipantDataChange('relacion', index, 'telefonoFijo', e.target.value)} /></div>
                              <div><strong>Tel. Celular:</strong> <Input size="small" value={participante.telefonoCelular} onChange={(e) => handleParticipantDataChange('relacion', index, 'telefonoCelular', e.target.value)} /></div>
                              <div><strong>Tiempo Residencia:</strong> <Input type="number" size="small" value={participante.tiempoResidencia} onChange={(e) => handleParticipantDataChange('relacion', index, 'tiempoResidencia', e.target.value)} /> años</div>
                              <div><strong>Correo:</strong> <Input size="small" value={participante.correoElectronico} onChange={(e) => handleParticipantDataChange('relacion', index, 'correoElectronico', e.target.value)} /></div>
                            </div>
                          )}
                          {firmasParticipantes[index] && (
                            <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                              <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                              <img
                                src={firmasParticipantes[index]}
                                alt={`Firma de ${participante.nombresApellidos || 'participante'}`}
                                style={{
                                  maxWidth: '100px',
                                  maxHeight: '50px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  padding: '2px',
                                  backgroundColor: '#fff'
                                }}
                              />
                            </div>
                          )}
                          {!isViewOnly && (
                            <div style={{ marginTop: '8px', textAlign: 'center' }}>
                              <span style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>Actualizar firma:</span>
                              <input
                                type="file"
                                accept="image/png, image/jpeg, .jfif"
                                style={{ fontSize: '9px' }}
                                onChange={(e) => handleParticipantSignatureChange(index, e)}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosRelacion?.fecha_firma || obtenerFechaFormateada()}.
                  <br />
                  <br />
                  <br />
                  {firmaRepresentante ? (
                    <img
                      src={firmaRepresentante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50px",
                        width: "auto",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999", marginLeft: 'auto' }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosRelacion.participantes?.[0]?.nombresApellidos}
                  </strong>
                  <br />
                  Representante legal
                </p>
              </div>
            </div>
          </div>
          {!isViewOnly && (
            <div className="acciones-documento" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '15px' }}>
              <div>
                <Button type="dashed" onClick={() => addParticipant('relacion')} icon={<i className="fa fa-plus" />}>
                  Agregar participante
                </Button>
              </div>
              <div className="accion-botones">
                <Button type="primary" onClick={() => guardarSubsanacionParticipantes('relacion')} style={{ background: '#0CA45D', borderColor: '#0CA45D' }}>
                  Guardar subsanación
                </Button>
              </div>
            </div>
          )}
        </Modal>
      )}
      {openCartaConformacionModal && (
        <Modal
          style={{ top: 20, zIndex: 3 }}
          visible={openCartaConformacionModal}
          footer={null}
          width={900}
          maskClosable={true}
          onCancel={() => setOpenCartaConformacionModal(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom" className="document-page">
              <h3 className="text-center">
                CARTA DE CONFORMACIÓN DE GRUPO
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
                <strong>
                  {isViewOnly ? (
                    datosCartaConformacion?.participantes?.[0]?.nombreGrupo
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '200px', display: 'inline-block' }}
                      value={datosCartaConformacion?.participantes?.[0]?.nombreGrupo}
                      onChange={(e) => handleParticipantDataChange('carta', 0, 'nombreGrupo', e.target.value)}
                    />
                  )}
                  {" "}
                </strong> y que hemos decidido participar en la línea {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong> {" "}
                para lo cual afirmamos conocer las condiciones generales y específicas de participación.
              </p>
              <p className="text-justify">
                Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
                <strong>
                  {isViewOnly ? (
                    datosCartaConformacion?.participantes?.[0]?.nombresApellidos
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '200px', display: 'inline-block' }}
                      value={datosCartaConformacion?.participantes?.[0]?.nombresApellidos}
                      onChange={(e) => handleParticipantDataChange('carta', 0, 'nombresApellidos', e.target.value)}
                    />
                  )}
                </strong> {" "}
                identificado(a) con{" "}
                <strong>
                  {isViewOnly ? (
                    datosCartaConformacion?.participantes?.[0]?.tipoDocumento
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '100px', display: 'inline-block' }}
                      value={datosCartaConformacion?.participantes?.[0]?.tipoDocumento}
                      onChange={(e) => handleParticipantDataChange('carta', 0, 'tipoDocumento', e.target.value)}
                    />
                  )}
                </strong> número{" "}
                <strong>
                  {isViewOnly ? (
                    datosCartaConformacion?.participantes?.[0]?.numeroDocumento
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '150px', display: 'inline-block' }}
                      value={datosCartaConformacion?.participantes?.[0]?.numeroDocumento}
                      onChange={(e) => handleParticipantDataChange('carta', 0, 'numeroDocumento', e.target.value)}
                    />
                  )}
                </strong>, quien está expresamente facultado(a) para firmar,
                presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
                documentos necesarios y tomar todas las decisiones que fueren necesarias.
              </p>
              <p className="text-justify">
                Además, manifestamos bajo gravedad de juramento que ninguno de los integrantes del  grupo relacionados a continuación, incluido el representante, está incurso en las limitantes  establecidas en la convocatoria.
              </p>
              <div>
                {datosCartaConformacion?.participantes && Array.isArray(datosCartaConformacion.participantes) && datosCartaConformacion.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '13px' }}>
                      <InfoCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
                      <strong>Nota:</strong> El primer participante que se agrega se considera el representante.
                    </div>
                    {datosCartaConformacion.participantes.map((participante: any, index: number) => {
                      const fechaNacimiento = formatFechaNacimiento(participante.fechaNacimiento);

                      return (
                        <div
                          key={participante.documento || participante.nombresApellidos}
                          style={{
                            border: '1px solid #ddd',
                            padding: '15px',
                            marginBottom: '10px',
                            borderRadius: '4px',
                            backgroundColor: '#fafafa',
                            position: 'relative'
                          }}
                        >
                          {!isViewOnly && (
                            <Button
                              type="text"
                              danger
                              icon={<i className="fa fa-trash" />}
                              style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1 }}
                              onClick={() => removeParticipant('carta', index)}
                            />
                          )}
                          {isViewOnly ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px' }}>
                              <div><strong>Nombres:</strong> {participante.nombresApellidos || "—"}</div>
                              <div><strong>Rol:</strong> {participante.rol || "—"}</div>
                              <div><strong>Tipo Doc:</strong> {participante.tipoDocumento || "—"}</div>
                              <div><strong>N° Doc:</strong> {participante.numeroDocumento || "—"}</div>
                              <div><strong>Fecha Nacimiento:</strong> {fechaNacimiento || "—"}</div>
                              <div><strong>Edad:</strong> {participante.edadCumplida || "—"}</div>
                              <div><strong>Dirección:</strong> {participante.direccionResidencia || "—"}</div>
                              <div><strong>Ciudad:</strong> {participante.ciudad || "—"}</div>
                              <div><strong>Tel. Fijo:</strong> {participante.telefonoFijo || "—"}</div>
                              <div><strong>Tel. Celular:</strong> {participante.telefonoCelular || "—"}</div>
                              <div><strong>Tiempo Residencia:</strong> {participante.tiempoResidencia || "—"} años</div>
                              <div><strong>Correo:</strong> {participante.correoElectronico || "—"}</div>
                            </div>
                          ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '11px' }}>
                              <div><strong>Nombres:</strong> <Input size="small" value={participante.nombresApellidos} onChange={(e) => handleParticipantDataChange('carta', index, 'nombresApellidos', e.target.value)} /></div>
                              <div><strong>Rol:</strong> <Input size="small" value={participante.rol} onChange={(e) => handleParticipantDataChange('carta', index, 'rol', e.target.value)} /></div>
                              <p className="text-justify" style={{ gridColumn: 'span 2' }}>
                                <strong>Tipo de documento: </strong>
                                <Radio.Group
                                  value={participante.tipoDocumento}
                                  onChange={(e) => handleParticipantDataChange('carta', index, 'tipoDocumento', e.target.value)}
                                >
                                  <Radio value="CC">CC</Radio>
                                  <Radio value="CE">CE</Radio>
                                  {convocatoria.menor_edad && (
                                    <Radio value="TI">TI</Radio>
                                  )}
                                </Radio.Group>
                              </p>
                              <div><strong>N° Doc:</strong> <Input size="small" value={participante.numeroDocumento} onChange={(e) => handleParticipantDataChange('carta', index, 'numeroDocumento', e.target.value)} /></div>
                              <p className="text-justify">
                                <strong>Fecha de nacimiento:</strong>
                                <DatePicker
                                  value={participante.fechaNacimiento ? moment(participante.fechaNacimiento) : null}
                                  disabledDate={disabledFechaNacimiento}
                                  style={{ width: '100%' }}
                                  onChange={(date) => handleParticipantDataChange('carta', index, 'fechaNacimiento', date)}
                                  format="YYYY-MM-DD"
                                  locale={locale}
                                />
                                {!convocatoria.menor_edad && participante.edadCumplida !== "" && participante.edadCumplida < 18 && (
                                  <small style={{ color: "#faad14" }}>
                                    {" "}No se permiten menores de 18 años
                                  </small>
                                )}
                              </p>
                              <div><strong>Edad:</strong> <Input size="small" value={participante.edadCumplida} readOnly disabled /></div>
                              <div><strong>Dirección:</strong> <Input size="small" value={participante.direccionResidencia} onChange={(e) => handleParticipantDataChange('carta', index, 'direccionResidencia', e.target.value)} /></div>
                              <div><strong>Ciudad:</strong> <Input size="small" value={participante.ciudad} onChange={(e) => handleParticipantDataChange('carta', index, 'ciudad', e.target.value)} /></div>
                              <div><strong>Tel. Fijo:</strong> <Input size="small" value={participante.telefonoFijo} onChange={(e) => handleParticipantDataChange('carta', index, 'telefonoFijo', e.target.value)} /></div>
                              <div><strong>Tel. Celular:</strong> <Input size="small" value={participante.telefonoCelular} onChange={(e) => handleParticipantDataChange('carta', index, 'telefonoCelular', e.target.value)} /></div>
                              <div><strong>Tiempo Residencia:</strong> <Input type="number" size="small" value={participante.tiempoResidencia} onChange={(e) => handleParticipantDataChange('carta', index, 'tiempoResidencia', e.target.value)} /> años</div>
                              <div><strong>Correo:</strong> <Input size="small" value={participante.correoElectronico} onChange={(e) => handleParticipantDataChange('carta', index, 'correoElectronico', e.target.value)} /></div>
                            </div>
                          )}
                          {firmasParticipantes[index] && (
                            <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                              <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                              <img
                                src={firmasParticipantes[index]}
                                alt={`Firma de ${participante.nombresApellidos || 'participante'}`}
                                style={{
                                  maxWidth: '100px',
                                  maxHeight: '50px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  padding: '2px',
                                  backgroundColor: '#fff'
                                }}
                              />
                            </div>
                          )}
                          {!isViewOnly && (
                            <div style={{ marginTop: '8px', textAlign: 'center' }}>
                              <span style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>Actualizar firma:</span>
                              <input
                                type="file"
                                accept="image/png, image/jpeg, .jfif"
                                style={{ fontSize: '9px' }}
                                onChange={(e) => handleParticipantSignatureChange(index, e)}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosCartaConformacion?.fecha_firma || obtenerFechaFormateada()}.
                  <br />
                  <br />
                  <br />
                  {firmaRepresentante ? (
                    <img
                      src={firmaRepresentante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50px",
                        width: "auto",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999", marginLeft: 'auto' }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosCartaConformacion.participantes?.[0]?.nombresApellidos}
                  </strong>
                  <br />
                  Representante del grupo
                </p>
              </div>
            </div>
          </div>
          {!isViewOnly && (
            <div className="acciones-documento" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '15px' }}>
              <div>
                <Button type="dashed" onClick={() => addParticipant('carta')} icon={<i className="fa fa-plus" />}>
                  Agregar integrante
                </Button>
              </div>
              <div className="accion-botones">
                <Button type="primary" onClick={() => guardarSubsanacionParticipantes('carta')} style={{ background: '#0CA45D', borderColor: '#0CA45D' }}>
                  Guardar subsanación
                </Button>
              </div>
            </div>
          )}
        </Modal>
      )}
      {openResidenciaGCModal && (
        <Modal
          style={{ top: 20, zIndex: 3 }}
          visible={openResidenciaGCModal}
          footer={null}
          width={900}
          maskClosable={true}
          onCancel={() => setOpenResidenciaGCModal(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom" className="document-page">
              <h3 className="text-center">
                DECLARACIÓN JURAMENTADA DE RESIDENCIA PARA GRUPOS CONFORMADOS
              </h3>
              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación
              </p>
              <p className="text-justify">
                Los suscritos abajo firmantes, manifestamos por medio de este documento, que conformamos el grupo {" "}
                <strong>
                  {isViewOnly ? (
                    datosResidenciaGC?.participantes?.[0]?.nombreGrupo
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '200px', display: 'inline-block' }}
                      value={datosResidenciaGC?.participantes?.[0]?.nombreGrupo}
                      onChange={(e) => handleParticipantDataChange('residenciaGC', 0, 'nombreGrupo', e.target.value)}
                    />
                  )}
                  {" "}
                </strong> y que hemos decidido participar en la línea {" "}
                <strong>{props.postulacion.linea_convocatoria}</strong> {" "}
                para lo cual afirmamos conocer las condiciones generales y específicas de participación.
              </p>
              <p className="text-justify">
                Para efectos del proceso de la convocatoria, designamos como representante del grupo a {" "}
                <strong>
                  {isViewOnly ? (
                    datosResidenciaGC?.participantes?.[0]?.nombresApellidos
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '200px', display: 'inline-block' }}
                      value={datosResidenciaGC?.participantes?.[0]?.nombresApellidos}
                      onChange={(e) => handleParticipantDataChange('residenciaGC', 0, 'nombresApellidos', e.target.value)}
                    />
                  )}
                </strong> {" "}
                identificado(a) con{" "}
                <strong>
                  {isViewOnly ? (
                    datosResidenciaGC?.participantes?.[0]?.tipoDocumento
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '100px', display: 'inline-block' }}
                      value={datosResidenciaGC?.participantes?.[0]?.tipoDocumento}
                      onChange={(e) => handleParticipantDataChange('residenciaGC', 0, 'tipoDocumento', e.target.value)}
                    />
                  )}
                </strong> número{" "}
                <strong>
                  {isViewOnly ? (
                    datosResidenciaGC?.participantes?.[0]?.numeroDocumento
                  ) : (
                    <Input
                      size="small"
                      style={{ width: '150px', display: 'inline-block' }}
                      value={datosResidenciaGC?.participantes?.[0]?.numeroDocumento}
                      onChange={(e) => handleParticipantDataChange('residenciaGC', 0, 'numeroDocumento', e.target.value)}
                    />
                  )}
                </strong>, quien está expresamente facultado(a) para firmar,
                presentar la propuesta, y en caso de resultar beneficiarios de un estímulo, firmar los
                documentos necesarios y tomar todas las decisiones que fueren necesarias.
              </p>
              <p>
                También, manifestamos que ninguno de los integrantes del grupo está incurso en las limitantes establecidas en la convocatoria.
              </p>
              <p className="text-justify">
                Además, los abajo firmantes, manifestamos la bajo gravedad de juramento, que nuestros lugares de residencia son los que se relacionan a continuación:
              </p>
              <div>
                {datosResidenciaGC?.participantes && Array.isArray(datosResidenciaGC.participantes) && datosResidenciaGC.participantes.length > 0 ? (
                  <div style={{ fontSize: '9px', marginTop: '20px' }}>
                    <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', marginBottom: '15px', borderRadius: '4px', fontSize: '13px' }}>
                      <InfoCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
                      <strong>Nota:</strong> El primer participante que se agrega se considera el representante.
                    </div>
                    {datosResidenciaGC.participantes.map((participante: any, index: number) => {
                      const fechaNacimiento = formatFechaNacimiento(participante.fechaNacimiento);

                      return (
                        <div
                          key={participante.documento || participante.nombresApellidos}
                          style={{
                            border: '1px solid #ddd',
                            padding: '15px',
                            marginBottom: '10px',
                            borderRadius: '4px',
                            backgroundColor: '#fafafa',
                            position: 'relative'
                          }}
                        >
                          {!isViewOnly && (
                            <Button
                              type="text"
                              danger
                              icon={<i className="fa fa-trash" />}
                              style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 1 }}
                              onClick={() => removeParticipant('residenciaGC', index)}
                            />
                          )}
                          {isViewOnly ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px' }}>
                              <div><strong>Nombres:</strong> {participante.nombresApellidos || "—"}</div>
                              <div><strong>Rol:</strong> {participante.rol || "—"}</div>
                              <div><strong>Tipo Doc:</strong> {participante.tipoDocumento || "—"}</div>
                              <div><strong>N° Doc:</strong> {participante.numeroDocumento || "—"}</div>
                              <div><strong>Fecha Nacimiento:</strong> {fechaNacimiento || "—"}</div>
                              <div><strong>Edad:</strong> {participante.edadCumplida || "—"}</div>
                              <div><strong>Dirección:</strong> {participante.direccionResidencia || "—"}</div>
                              <div><strong>Ciudad:</strong> {participante.ciudad || "—"}</div>
                              <div><strong>Tel. Fijo:</strong> {participante.telefonoFijo || "—"}</div>
                              <div><strong>Tel. Celular:</strong> {participante.telefonoCelular || "—"}</div>
                              <div><strong>Tiempo Residencia:</strong> {participante.tiempoResidencia || "—"} años</div>
                              <div><strong>Correo:</strong> {participante.correoElectronico || "—"}</div>
                            </div>
                          ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '11px' }}>
                              <div><strong>Nombres:</strong> <Input size="small" value={participante.nombresApellidos} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'nombresApellidos', e.target.value)} /></div>
                              <div><strong>Rol:</strong> <Input size="small" value={participante.rol} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'rol', e.target.value)} /></div>
                              <p className="text-justify" style={{ gridColumn: 'span 2' }}>
                                <strong>Tipo de documento: </strong>
                                <Radio.Group
                                  value={participante.tipoDocumento}
                                  onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'tipoDocumento', e.target.value)}
                                >
                                  <Radio value="CC">CC</Radio>
                                  <Radio value="CE">CE</Radio>
                                  {convocatoria.menor_edad && (
                                    <Radio value="TI">TI</Radio>
                                  )}
                                </Radio.Group>
                              </p>
                              <div><strong>N° Doc:</strong> <Input size="small" value={participante.numeroDocumento} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'numeroDocumento', e.target.value)} /></div>
                              <p className="text-justify">
                                <strong>Fecha de nacimiento:</strong>
                                <DatePicker
                                  value={participante.fechaNacimiento ? moment(participante.fechaNacimiento) : null}
                                  disabledDate={disabledFechaNacimiento}
                                  style={{ width: '100%' }}
                                  onChange={(date) => handleParticipantDataChange('residenciaGC', index, 'fechaNacimiento', date)}
                                  format="YYYY-MM-DD"
                                  locale={locale}
                                />
                                {!convocatoria.menor_edad && participante.edadCumplida !== "" && participante.edadCumplida < 18 && (
                                  <small style={{ color: "#faad14" }}>
                                    {" "}No se permiten menores de 18 años
                                  </small>
                                )}
                              </p>
                              <div><strong>Edad:</strong> <Input size="small" value={participante.edadCumplida} readOnly disabled /></div>
                              <div><strong>Dirección:</strong> <Input size="small" value={participante.direccionResidencia} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'direccionResidencia', e.target.value)} /></div>
                              <div><strong>Ciudad:</strong> <Input size="small" value={participante.ciudad} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'ciudad', e.target.value)} /></div>
                              <div><strong>Tel. Fijo:</strong> <Input size="small" value={participante.telefonoFijo} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'telefonoFijo', e.target.value)} /></div>
                              <div><strong>Tel. Celular:</strong> <Input size="small" value={participante.telefonoCelular} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'telefonoCelular', e.target.value)} /></div>
                              <div><strong>Tiempo Residencia:</strong> <Input type="number" size="small" value={participante.tiempoResidencia} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'tiempoResidencia', e.target.value)} /> años</div>
                              <div><strong>Correo:</strong> <Input size="small" value={participante.correoElectronico} onChange={(e) => handleParticipantDataChange('residenciaGC', index, 'correoElectronico', e.target.value)} /></div>
                            </div>
                          )}
                          {firmasParticipantes[index] && (
                            <div style={{ marginTop: '8px', textAlign: 'center', borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                              <div style={{ fontSize: '9px', marginBottom: '4px', fontWeight: 'bold' }}>Firma:</div>
                              <img
                                src={firmasParticipantes[index]}
                                alt={`Firma de ${participante.nombresApellidos || 'participante'}`}
                                style={{
                                  maxWidth: '100px',
                                  maxHeight: '50px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px',
                                  padding: '2px',
                                  backgroundColor: '#fff'
                                }}
                              />
                            </div>
                          )}
                          {!isViewOnly && (
                            <div style={{ marginTop: '8px', textAlign: 'center' }}>
                              <span style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }}>Actualizar firma:</span>
                              <input
                                type="file"
                                accept="image/png, image/jpeg, .jfif"
                                style={{ fontSize: '9px' }}
                                onChange={(e) => handleParticipantSignatureChange(index, e)}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-justify" style={{ fontSize: '12px' }}>
                    No hay participantes registrados.
                  </p>
                )}
              </div>
              <div>
                <p className="text-right">
                  En constancia, se firma en Medellín a los {datosResidenciaGC?.fecha_firma || obtenerFechaFormateada()}.
                  <br />
                  <br />
                  <br />
                  {firmaRepresentante ? (
                    <img
                      src={firmaRepresentante}
                      alt="Firma del representante legal"
                      style={{
                        height: "50px",
                        width: "auto",
                        borderTop: "none",
                      }}
                    />
                  ) : (
                    <div style={{ height: "100px", width: "50%", border: "1px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", color: "#999", marginLeft: 'auto' }}>
                      Sin firma
                    </div>
                  )}
                  <br />
                  <strong>
                    {datosResidenciaGC.participantes?.[0]?.nombresApellidos}
                  </strong>
                  <br />
                  Representante del grupo
                </p>
              </div>
            </div>
          </div>
          {!isViewOnly && (
            <div className="acciones-documento" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '15px' }}>
              <div>
                <Button type="dashed" onClick={() => addParticipant('residenciaGC')} icon={<i className="fa fa-plus" />}>
                  Agregar integrante
                </Button>
              </div>
              <div className="accion-botones">
                <Button type="primary" onClick={() => guardarSubsanacionParticipantes('residenciaGC')} style={{ background: '#0CA45D', borderColor: '#0CA45D' }}>
                  Guardar subsanación
                </Button>
              </div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
};
